<template>
  <div
    id="subscriptionModal"
    data-modal-backdrop="static"
    tabindex="-1"
    aria-hidden="true"
    class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
  >
    <div class="relative p-4 w-full max-w-2xl max-h-full">
      <div class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
        <div class="flex items-center justify-between p-4 rounded-t">
          <h3 class="text-xl lg:text-2xl font-semibold text-gray-900 dark:text-white">
            Upgrade plan to use all features
          </h3>
          <button
            type="button"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
            data-modal-hide="subscriptionModal"
          >
            <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
        </div>

        <div class="p-4 bg-yellow-50 dark:bg-stone-900 max-h-[70vh] overflow-scroll">
          <PricingCards />
        </div>

        <div class="flex items-center p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
          <button @click="gotoPricingPage" class="btn btn--blue btn--lg mx-auto">Detail</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useSubscriptionStore } from '$/stores/subscription'
  import { onBeforeUnmount, onMounted } from 'vue'
  import { Modal } from 'flowbite'
  import PricingCards from '&/landing_pages/PricingCards.vue'

  const subscriptionStore = useSubscriptionStore()

  onMounted(() => {
    createModal()
  })

  onBeforeUnmount(() => {
    subscriptionStore.subscriptionModal.hide()
  })

  function createModal() {
    subscriptionStore.subscriptionModal = null

    const $modal = document.getElementById('subscriptionModal')
    const modalOptions = {}

    subscriptionStore.subscriptionModal = new Modal($modal, modalOptions)
  }

  function gotoPricingPage() {
    window.location.href = '/pricing'
  }
</script>
